
    const html = "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\"> <a href ng-click=select($event) class=nav-link uib-tab-heading-transclude>{{heading}}</a> </li> ";
    angular.module('ng').run(['$templateCache', function($templateCache){
      $templateCache.put('uib/template/tabs/tab.html', html);
    }]);
    module.exports = 'uib/template/tabs/tab.html';
  